import React, {useState, useEffect, useContext} from 'react';
import { getEmptyImage } from "react-dnd-html5-backend";
import { useDrag, DragSourceMonitor } from "react-dnd";
import { useLocation } from "react-router-dom";
import {IProps} from './types';
import * as S from './styles';
import C from '@assets/themes/colors';
import { PreviewForm } from '@assets/icons/previewForm';
import OptionIcon from '@assets/icons/optionIcon';
import FavoriteDesignIcon from '@assets/icons/favoriteDesignIcon';
import IconButton from '@components/IconButton';
import PreviewComponentOptions from '../PreviewComponentOptions';
import EditDesign from '../EditDesign';
import PreviewGrid from '../PreviewGrid';
import { StudioContext } from '@utils/DOIgnition/StudioContext';
import { getOEMName } from 'utils/editor';
import { useSelector } from 'react-redux';
import selectors from '@state/selectors';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import { DesignsContext } from '@utils/DOIgnition/DesignsContext';
import { useDispatch } from 'react-redux';
import actions from '@state/actions';
import FullPreview from '../FullPreview';
import { TemplatesContext } from '@utils/DOIgnition/TemplatesContext';
import Options from '@components/Options';

const PreviewComponent:React.FC<IProps> = (props) => {
  const dsConfig = useSelector(selectors.dsConfig.getDSConfig);

  const authContext = useContext(AuthContext);
  const designsContext = useContext(DesignsContext);
  const dispatch = useDispatch();

  const studioContext = useContext(StudioContext);
  const templateContext = useContext(TemplatesContext)

  const [selected, setSelected] = useState( false ); 
  const [openOptions, setOpenOptions] = useState(false);
  const [coordinates, setCoordinates] = useState({x: 0, y: 0});
  const [openEdit, setOpenEdit] = useState(false);
  const [viewPreview, setViewPreview] = useState(false);
  let location = useLocation();
  
  const { item } = props;
  let left=0, top =0;
  const [{ isDragging }, drag, preview] = useDrag(
    () => ({
      type: 'DESIGN',
      item: { item, top, left },
      collect: (monitor: DragSourceMonitor) => ({
        isDragging: monitor.isDragging(),
      }),
    }),
    [item, left, top],
  );

  useEffect(() => {
    if (preview) {      
      preview(getEmptyImage(), { captureDraggingState: true });
    }
  }, [preview]);

  useEffect(() => {
    if (props.selected!==undefined) setSelected(props.selected);
  }, [props.selected])

  const handleMouseSizes = (e: any) => {
    if (openOptions === false) setCoordinates({x: e.clientX, y: e.clientY});
  }

  const renderSizes = () => {
    var sizes = "";
    var sizesArray: any = [];
    if (props.item.tags?.formats && props.item.tags.formats.length > 0) {
      props.item.tags.formats.map((format: any, index: number) => {
        if (index < 3) sizesArray.push(`${format.width}x${format.height}`);
      })
      sizes = sizesArray.join(", ");
      if (props.item.tags.formats.length > 3) {
        return (
          <>
            {sizes}
            <S.SubtitleBold>
              +{props.item.tags.formats.length - 3}
            </S.SubtitleBold>
            { 
              openOptions === false &&
              <S.FormatsAbsoluteContainer
                id={`formats-hover-${props.item.id}`}
                leftValue={`${coordinates.x - 100}px`}
                bottomValue={`${window.innerHeight - coordinates.y - 60}px`}
              >
                <S.FormatsContainer>
                  {
                    props.item.tags.formats.map((format: any, index: number) => {
                      return (
                        <S.FormatLabel key={index} >
                          {`${format.name} - ${format.width}px x ${format.height}px`}
                        </S.FormatLabel>
                      )
                    })
                  }
                </S.FormatsContainer>
              </S.FormatsAbsoluteContainer>
            }
          </>
        )
      }
    }
    return sizes;
  }

  const renderCornerSize = () => {
    var sizes = "No sizes";
    if (props.item.tags?.formats && props.item.tags.formats.length) {
      if (props.item.tags.formats.length === 1) {
        props.item.tags.formats.map((format: any) => {
          sizes = `${format.width}x${format.height}`;
        })
      } else {
        sizes = `${props.item.tags.formats.length} sizes`;
      }
    }
    return sizes;
  }

  const renderCustomTags = () => {
    var customTags = "";
    if (props.item.tags?.customTags && props.item.tags?.customTags.length > 0) {
      customTags = props.item.tags?.customTags.join(' - ');
    } else if (props.item.tags?.platform && props.item.tags?.oem) {
      customTags = `${props.item.tags.platform} - ${getOEMName(props.item.tags.oem, dsConfig)}`
    }
    return customTags;
  }

  const handleOpenOptions = (e: any) => {
    e.stopPropagation();
    setOpenOptions(!openOptions);
    setCoordinates({x: e.clientX, y: e.clientY});
  }

  const createTemplateFromDesign = (idDesign: string, designName: string) => {
    return new Promise((resolve, reject) => {
      const userData = {
        email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
        name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
      };
      dispatch(actions.designs.createTemplateFromDesign({idDesign: idDesign, designName: designName, userData: userData}, (result: any, error: any) => {
        if (error) {
          reject(error);
        }
        else {
          resolve(result);
        }
      }))
      setOpenOptions(false);
    })
  }

  const handleActions = (action: string) => {    
    if (action==="NAMEFOLDER") setOpenEdit(true);
    if (action==="SAVEASTEMPLATE") createTemplateFromDesign(item.id, item.name);
    if (action==="PREVIEW") setViewPreview(true);
    else if (props.onActions) props.onActions(props.item, action);
  }

  const handleActionsTemplate = (action: string, item: any, idx: number) => {    
    if (action==="PREVIEW") setViewPreview(true); 
    else if (props.onActionsTemplate) props.onActionsTemplate(action, item, idx);
  }

  const handleEdit = (action: string, folder:number) => {
    if (props.onActions) props.onActions(props.item, action, folder);
  }

  const handleClick = (e: any) => {
    if (e.shiftKey && props.handleSelectedIndexes) {
      if (props.selected) {
        props.handleSelectedIndexes(props.index, 'REMOVE');
      } else {
        props.handleSelectedIndexes(props.index, 'ADD');
      }
      return;
    }
    if (location.pathname==="/studio" && studioContext && props.item.entityType==="TEMPLATE") {
      if (props.clearSearch) props.clearSearch();
      studioContext.addDesignFromTemplate(props.item);
    } else if (e.shiftKey && !designsContext?.sharedFiles?.open) {
      if (props.onActions) {
        if (!props.selected) props.onActions(props.item, 'ADDDESIGN', -1);
        else props.onActions(props.item, 'DELETEDESIGN', -1);
      }
    }
    else if (props.item.entityType==="DESIGN" && !e.shiftKey) window.open(`/editor/design/${props.item.id}`);
    else if (props.item.entityType==="TEMPLATE" && !e.shiftKey) window.open(`/editor/template/${props.item.id}`);
  }

  const handleContextMenu = (e: any) => {
    if (props.selected && props.setOpen) {
      e.preventDefault();
      props.setOpen(true);
    }
  }

  const renderMetadata = () => {
    return (
      <>
        <S.MetaDataTitle>
          Tags:
        </S.MetaDataTitle>
        <S.MetaDataCustomTags>
          {renderCustomTags()}
        </S.MetaDataCustomTags>
      </>
    )
  }

  return (
    <S.Root
      id={props.id ? props.id : `preview-component-${props.item?.id}`}
      ref={location.pathname==="/my-designs" ? drag : null}
      data-draggable="true"
      onContextMenu={handleContextMenu}
    >
      <S.MainContainer onClick={(e) => handleClick(e)}>
        <S.BoxContainer onMouseEnter={handleMouseSizes} >
          <S.PreviewContainer selected={selected || isDragging ? true : false }>
            <S.InfoExtraContainer border={props.item.favorite}>
              {
                props.item.tags?.formats && props.item.tags.formats.length > 1 &&
                <S.Sizes border={props.item.favorite}>
                  {renderCornerSize()}
                </S.Sizes>
              }
              {props.item.favorite && 
                <S.Favorite border={props.item.tags?.formats && props.item.tags.formats.length > 1 ? true : false}>
                  <FavoriteDesignIcon/>
                </S.Favorite>
              }
            </S.InfoExtraContainer >
            {
              props.item?.previews?.length > 0 ?
                <S.PreviewContent>
                  <PreviewGrid
                    images={props.item.previews}
                    designType={props.item.tags?.designType}
                  />
                </S.PreviewContent>
              :
                <PreviewForm />
            }
            {
              props.showMetadata === true && !selected &&
              <S.MetaDataContainer>
                <S.MetaData>
                  <S.MetaDataOptionIconContainer>
                    <IconButton
                      containerStyles={{transform: 'scale(0.7)'}}
                      action={handleOpenOptions}
                    >
                      <OptionIcon
                        style={{fillColor: C.WHITE}}
                      />
                    </IconButton>
                  </S.MetaDataOptionIconContainer>
                  {renderMetadata()}
                  <S.MetadataBottomGradient />
                </S.MetaData>
              </S.MetaDataContainer>
            }
          </S.PreviewContainer>
          {
            props.item.tags?.customTags.length > 0 &&
            <S.HoverMetaDataContainer
              id={`metadata-hover-${props.item.id}`}
              leftValue={`${coordinates.x - 100}px`}
              bottomValue={`${window.innerHeight - coordinates.y - 60}px`}
            >
              <S.HoverMetaData>
                {renderMetadata()}
              </S.HoverMetaData>
            </S.HoverMetaDataContainer>
          }
        </S.BoxContainer>
        <S.BottomContainer>
          <S.Title>
            {props.item.name}
          </S.Title>
          <S.Subtitle
            onMouseEnter={handleMouseSizes}
          >
            {renderSizes()}
          </S.Subtitle>
        </S.BottomContainer>
      </S.MainContainer>
      {
        openOptions && item.entityType === "DESIGN" && 
        <PreviewComponentOptions
          open={openOptions}
          setOpen={setOpenOptions}
          coordinates={coordinates}
          labels={{
            name: props.item.name,
            designType: props.item.tags.designType,
            createdDate: new Intl.DateTimeFormat('en-US',{day:'2-digit', month:'2-digit', year:'2-digit'}).format(new Date(props.item.createdDate)),
            userName: props.item.createdBy?.name ? props.item.createdBy.name : "Default User",
            lastEditedDate: new Intl.DateTimeFormat('en-US',{day:'2-digit', month:'2-digit', year:'2-digit'}).format(new Date(props.item.updateDate)),
          }} 
          onActions={handleActions}
          design={props.item}
        />
      }
      {
        openOptions && item.entityType === "TEMPLATE" && 
        <Options
          index={props.index}
          open={openOptions}
          setOpen={setOpenOptions}
          coordinates={coordinates}
          item={item}
          designType={item.tags.designType}
          createdDate={new Intl.DateTimeFormat('en-US',{day:'2-digit', month:'2-digit', year:'2-digit'}).format(new Date(item.createdDate))}
          userName={item.createdBy?.name ? item.createdBy.name : "Default User"}
          lastEditedDate={new Intl.DateTimeFormat('en-US',{day:'2-digit', month:'2-digit', year:'2-digit'}).format(new Date(item.updateDate))}
          onActionsTemplate={(action: string, item: any, idx: number) => handleActionsTemplate(action, item, idx)}
        />
      }
      {
        openEdit &&
        <EditDesign
          open = {openEdit}
          setOpen = {setOpenEdit}
          design = {props.item}
          onEditMyDesigns={handleEdit}
        />
      } 
      {
        viewPreview && 
        <FullPreview
          open={viewPreview}
          setOpen={setViewPreview}
          item={props.item}
          onAcion={()=>{}}        
          onTagSelected={(tag:string)=>{            
            templateContext.setSearchValue(tag)    
            templateContext.setForceSearch(true)
          }}  
        />
      }
    </S.Root >
  );
}

export default PreviewComponent;